import { useLogger } from 'common';
import { useState, useEffect, useRef } from 'react';

export function useInactivityDetection(timeoutSeconds: number = 300) {
  const [isIdle, setIsIdle] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const logger = useLogger('useInactivityDetection');
  const events = ['keypress', 'touchstart', 'click'];

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      setIsIdle(false);
      timerRef.current = setTimeout(handleTimeout, timeoutSeconds * 1000);
    };

    const handleTimeout = () => {
      logger.info('Inactivity timeout reached');
      setIsIdle(true);
    };

    const handleEvent = (e: Event) => {
      logger.info(`Inactivity reset ${e.type}`);
      resetTimer();
    };

    events.forEach((event) => {
      document.addEventListener(event, handleEvent, { passive: true });
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleEvent);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [timeoutSeconds]);

  return { isIdle };
}
